export interface Experience {
  company: string;
  title: string;
  startDate: Date;
  endDate: Date | undefined;
  location: string;
  workFromHome: 'Hybrid' | 'WFH' | '';
  additionalInformation: string[];
  key: string;
}

export const experience: Experience[] = [
  {
    company: 'Easebuzz Payment Solutions (Fintech)',
    title: 'SDE 3',
    startDate: new Date(2023, 0),
    endDate: new Date(),
    location: '',
    workFromHome: '',
    additionalInformation: [
      "As a crucial member of the Neobanking Operations team at Easebuzz, I specialize in managing virtual account operations and driving key initiatives.",
      "Notably, I've led the implementation of Smartx, an Enterprise Expense Management Project. Smartx streamlines expense tracking with features such as detailed expense reports, receipts, taxes, and an advanced approver hierarchy. It facilitates grouping and submission of expenses, offers a resubmission facility, user policies, and seamless reimbursement through the Neobanking micro-service post hierarchy approval.",
      "I've also played a pivotal role in HDFC bulk payments integration, successfully implementing bank integration initiatives, including account statements APIs. This significantly optimized financial processes, contributing to enhanced operational efficiency.",
      "Alongside these achievements, I maintain a hands-on approach in product improvement, consistently delivering high-quality code and ensuring code integrity through regular reviews.",
      "Actively participating in strategic planning, I contribute valuable insights for accurate project deadline estimations, ensuring timely delivery of our fintech solutions and reinforcing Easebuzz's reputation for efficiency and excellence in financial technology."
    ],
    key:'dididid'
  },
  {
    company: 'Mobiux.in',
    title: 'SDE',
    startDate: new Date(2021, 7),
    endDate: new Date(2022, 12),
    location: '',
    workFromHome: '',
    additionalInformation: [
      "Designed and implemented a comprehensive internal tool for managing student applications. Features include dashboards monitoring student activities and sales analytics, scheduling doubt sessions with mentors, and sending bulk emails to students. The tool allows for different roles, with student sign-ups via Typeform and integration with AWS Lambdas in a serverless architecture. Additionally, Freshsales is utilized for deal creation. The tool is built entirely in Angular (Ionic) with NgRx for state management.",
      "Developed a customer-facing website facilitating student tracking of course progress, assignment reading and writing. Instructors can build content with features allowing the creation and rearrangement of slides."
    ],
       key: 'chamber-of-commerce',
  },
  {
    company: 'BESTSTUDENTHALLS.COM',
    title: 'Full Stack Software Developer Freelance',
    startDate: new Date(2021, 5),
    endDate: new Date(2021, 6),
    location: '',
    workFromHome: '',
    additionalInformation: [
    'My work here was to work as a fullstack developer , that is from creating complete landing pages ( as a ad redirect ) to working on increasing the performance of the website to creating backend form handling in Django , redirecting it to freshsales API for the sales team to handle leads'],
    key: 'best',
  },
  {
    company: 'Q-in-1.com',
    title: 'Analyst',
    startDate: new Date(2020, 8),
    endDate: new Date(2021, 3),
    location: '',
    workFromHome: '',
    additionalInformation: [
       'Qin1.com was an Edtech startup where my role was to contribute to increasing the overall teaching experience. I worked directly under the founders and contributed in management , training of trainers and curriculum development. The job also required data analysis regarding Ad marketing analysis , and trainer demo conversion rate analysis' ],
    key: 'qin',
  },
];
